import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { ICard } from '../../../../common/interfaces/ICard';
import { Card } from '../Card/Card';
import styles from './List.module.scss';

interface SortableListProps {
  cards: ICard[];
  listId: number;
  dragOverInfo: {
    cardId: number;
    targetListId: number;
    position: number;
  } | null;
  onOpenCard: (card: ICard) => void;
}

export function SortableList({ cards, listId, dragOverInfo, onOpenCard }: SortableListProps) {
  const sortedCards = cards.toSorted((a: ICard, b: ICard) => a.position - b.position);

  const isTargetList = dragOverInfo?.targetListId === listId;
  const targetPosition = dragOverInfo?.position ?? -1;

  const shouldShowPreview =
    isTargetList &&
    dragOverInfo &&
    dragOverInfo.cardId &&
    !cards.some((card: ICard) => card.id === dragOverInfo.cardId);

  const sortableItems = sortedCards.length > 0 ? sortedCards.map((c: ICard) => c.id) : [`empty-list-${listId}`];

  const renderCards = () => {
    if (!shouldShowPreview) {
      return sortedCards.map((card: ICard) => (
        <Card key={card.id} card={card} listId={listId} onOpenCard={onOpenCard} />
      ));
    }

    const result: React.ReactNode[] = [];

    if (sortedCards.length === 0) {
      result.push(
        <div key="preview" className={styles.cardPreview}>
          <div className={styles.cardPreviewContent}>
            <p>Drop card here</p>
          </div>
        </div>
      );
      return result;
    }

    for (let i = 0; i < targetPosition && i < sortedCards.length; i++) {
      const card = sortedCards[i];
      result.push(<Card key={card.id} card={card} listId={listId} onOpenCard={onOpenCard} />);
    }

    result.push(
      <div key="preview" className={styles.cardPreview}>
        <div className={styles.cardPreviewContent}>
          <p>Drop card here</p>
        </div>
      </div>
    );

    for (let i = targetPosition; i < sortedCards.length; i++) {
      const card = sortedCards[i];
      result.push(<Card key={card.id} card={card} listId={listId} onOpenCard={onOpenCard} />);
    }

    return result;
  };

  return (
    <div className={styles.listCards}>
      <SortableContext items={sortableItems} strategy={verticalListSortingStrategy}>
        {sortedCards.length === 0 && !shouldShowPreview && (
          <div className={styles.emptyPlaceholder}>
            <p>Drop card here</p>
          </div>
        )}
        {renderCards()}
      </SortableContext>
    </div>
  );
}
